import React from "react";
import { Navigate } from "react-router-dom";
import { PageLayout } from "src/components";
import { ERoutes, EUrlParams } from "src/types";
import "./payment-redirect.scss";

const PaymentRedirect: React.FC = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const redirectUrl = searchParams.get(EUrlParams.RedirectUrl);

  if (!redirectUrl) {
    return <Navigate to={ERoutes.NotFound} replace />;
  }

  return (
    <PageLayout>
      <div className="payment-redirect">
        <iframe src={redirectUrl} title="Payment" className="payment-redirect-iframe" allow="payment" />
      </div>
    </PageLayout>
  );
};

export default PaymentRedirect;
